var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9174 10.9893L9.07221 8.14414C9.01831 8.09024 8.948 8.06211 8.873 8.06211H8.56364C9.30189 7.20669 9.74952 6.09346 9.74952 4.87477C9.74952 2.18194 7.5676 1.52588e-05 4.87476 1.52588e-05C2.18192 1.52588e-05 0 2.18194 0 4.87477C0 7.56761 2.18192 9.74953 4.87476 9.74953C6.09345 9.74953 7.20668 9.3019 8.06211 8.56365V8.87301C8.06211 8.94801 8.09257 9.01832 8.14413 9.07222L10.9893 11.9174C11.0995 12.0275 11.2776 12.0275 11.3877 11.9174L11.9174 11.3877C12.0275 11.2776 12.0275 11.0995 11.9174 10.9893ZM4.87476 8.62459C2.80299 8.62459 1.12495 6.94654 1.12495 4.87477C1.12495 2.803 2.80299 1.12496 4.87476 1.12496C6.94654 1.12496 8.62458 2.803 8.62458 4.87477C8.62458 6.94654 6.94654 8.62459 4.87476 8.62459Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.238050b8.svg";
export { ForwardRef as ReactComponent };